import React from 'react';
import { forgeProjectSettingsModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { projectContextResourceWithCache } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import type ForgeProjectSettingsPageType from '@atlassian/jira-spa-apps-forge-project-settings/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyForgeProjectSettingsPage = lazyForPaint<typeof ForgeProjectSettingsPageType>(
	() =>
		import(
			/* webpackChunkName: "async-forge-spa-project-settings", jiraSpaEntry: "async-forge-spa-project-settings" */ '@atlassian/jira-spa-apps-forge-project-settings'
		),
);

export const forgeProjectSettingsPageResources = () =>
	[projectContextResourceWithCache, forgeProjectSettingsModuleResource] as const;

export const ForgeProjectSettingsPage = () => (
	<LazyPage
		Page={LazyForgeProjectSettingsPage}
		pageId="forge-spa-project-settings"
		shouldShowSpinner
	/>
);

export default ForgeProjectSettingsPage;
